document.addEventListener("DOMContentLoaded", function () {
  // Función global para mostrar alertas
  window.showAlert = function ({ title, text, confirmText, url }) {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        title: `<strong class="custom-swal-acceso-title">${
          title || "¡Aviso!"
        }</strong>`,
        html: `<p class="custom-swal-acceso-text">${
          text || "Esto es un mensaje global."
        }</p>`,
        confirmButtonText: confirmText || "Aceptar",
        showCloseButton: true,
        allowOutsideClick: false,
        customClass: {
          popup: "custom-swal-acceso-popup",
          confirmButton: "custom-swal-acceso-btn",
          closeButton: "custom-swal-acceso-close",
        },
      }).then((result) => {
        if (result.isConfirmed && url) {
          window.open(url, "_blank");
        }
      });
    } else {
    }
  };

  // Función global para mostrar el carrusel con productos en promoción
  window.showCarouselPromotion = function () {
    if (!window.imagenesProductos || window.imagenesProductos.length === 0) {
      console.error("No hay imágenes de productos en promoción.");
      return;
    }

    Swal.fire({
      title: "Productos en Promoción",
      html: `
      <div class="swiper swiper-modal">
        <div class="swiper-wrapper">
          ${window.imagenesProductos
            .map((img) =>
              img.trim().startsWith("<svg")
                ? `<div class="swiper-slide" style="height: 100%!important;">${img}</div>`
                : `<div class="swiper-slide" style="height: 100%!important;"><img src="${img}" class="img-responsive"></div>`
            )
            .join("")}
        </div>
        <!-- Paginación -->
        <div class="swiper-pagination" style="top: 96% !important; left: 0% !important;"></div>
        <!-- Botones de navegación -->
        <div class="custom-swiper-button-next swiper-button-next">&#10095;</div>
        <div class="custom-swiper-button-prev swiper-button-prev">&#10094;</div>
      </div>`,
      showCloseButton: true,
      showConfirmButton: false,
      width: 600,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        setTimeout(() => {
          const swiperContainer = document.querySelector(".swiper-modal");

          if (!swiperContainer) {
            console.error("No se encontró el contenedor del Swiper.");
            return;
          }

          if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy(true, true);
          }

          const nextButton = document.querySelector(
            ".custom-swiper-button-next"
          );
          const prevButton = document.querySelector(
            ".custom-swiper-button-prev"
          );

          if (!nextButton || !prevButton) {
            console.error("No se encontraron los botones de navegación.");
            return;
          }

          new Swiper(".swiper-modal", {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            centeredSlides: true,
            observer: true,
            observeParents: true,
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
            pagination: {
              el: ".swiper-pagination",
              type: "fraction",
            },
          });
        }, 300);
      },
    });
  };

  const botonBanner = document.querySelector(".boton-banner");
  if (botonBanner) {
    botonBanner.addEventListener("click", showCarouselPromotion, false);
  }

  // Función global para mostrar el carrusel de acerditacion

  window.showCarouselAccreditation = function () {
    if (
      !window.imagenesCertificados ||
      typeof window.imagenesCertificados !== "object"
    ) {
      console.error("No images available.");
      return;
    }

    let currentTab = arguments[0];

    function getImagesHTML(category) {
      let images = window.imagenesCertificados[category] || [];
      return images
        .map((img) =>
          img.trim().startsWith("<svg")
            ? `<div class="swiper-slide" style="height: 100%!important"><div class="image-container">${img}</div></div>`
            : `<div class="swiper-slide" style="height: 100%!important;"><div class="image-container"><img src="${img}" class="img-responsive" style="padding: 5rem 0rem 0rem;"></div></div>`
        )
        .join("");
    }

    function updateCarousel() {
      const swiperContainer = document.querySelector(".swiper-modal");
      if (!swiperContainer) return;

      if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
      }

      const parent = swiperContainer.parentNode;
      parent.removeChild(swiperContainer);

      const newSwiper = document.createElement("div");
      newSwiper.className = "swiper swiper-modal";

      const totalSlides = (window.imagenesCertificados[currentTab] || [])
        .length;
      const showNavigation = totalSlides > 1;

      newSwiper.innerHTML = `
      <div class="swiper-wrapper">${getImagesHTML(currentTab)}</div>
      <div class="swiper-pagination" style="top: 93% !important; left: 0% !important;"></div>
      ${
        showNavigation
          ? `
        <div class="custom-swiper-button-next swiper-button-next">&#10095;</div>
        <div class="custom-swiper-button-prev swiper-button-prev">&#10094;</div>
      `
          : ""
      }
    `;

      parent.appendChild(newSwiper);

      setTimeout(() => {
        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: showNavigation,
          centeredSlides: true,
          observer: true,
          observeParents: true,
          watchOverflow: true,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
        };

        if (showNavigation) {
          swiperOptions.navigation = {
            nextEl: ".custom-swiper-button-next",
            prevEl: ".custom-swiper-button-prev",
          };
        }

        new Swiper(".swiper-modal", swiperOptions);
      }, 50);
    }

    Swal.fire({
      title: `
      <div class="tabs-container">
        <button class="tab active" data-tab="Acreditación EMA">Acreditación EMA</button>
        <button class="tab" data-tab="Control de calidad externo">Control de calidad externo</button>
        <button class="tab" data-tab="Control de calidad interno">Control de calidad interno</button>
      </div>`,
      html: `
      <div id="swiper-container">
        <div class="swiper swiper-modal">
          <div class="swiper-wrapper">${getImagesHTML(currentTab)}</div>
          <div class="swiper-pagination" style="top: 93% !important; left: 0% !important;"></div>
        </div>
      </div>`,
      showCloseButton: true,
      showConfirmButton: false,
      width: 700,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: "custom-swal",
      },
      didOpen: () => {
        setTimeout(() => {
          const totalSlides = (window.imagenesCertificados[currentTab] || [])
            .length;
          const showNavigation = totalSlides > 1;

          if (showNavigation) {
            const swiperContainer = document.querySelector(".swiper-modal");
            const nextBtn = document.createElement("div");
            const prevBtn = document.createElement("div");

            nextBtn.className = "custom-swiper-button-next swiper-button-next";
            nextBtn.innerHTML = "&#10095;";
            prevBtn.className = "custom-swiper-button-prev swiper-button-prev";
            prevBtn.innerHTML = "&#10094;";

            swiperContainer.appendChild(nextBtn);
            swiperContainer.appendChild(prevBtn);
          }

          const swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: showNavigation,
            centeredSlides: true,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            pagination: {
              el: ".swiper-pagination",
              type: "fraction",
            },
          };

          if (showNavigation) {
            swiperOptions.navigation = {
              nextEl: ".custom-swiper-button-next",
              prevEl: ".custom-swiper-button-prev",
            };
          }

          new Swiper(".swiper-modal", swiperOptions);

          let tabToActivate = document.querySelector(
            `.tab[data-tab="${currentTab}"]`
          );
          if (tabToActivate) {
            document
              .querySelectorAll(".tab")
              .forEach((t) => t.classList.remove("active"));
            tabToActivate.classList.add("active");
          }

          document.querySelectorAll(".tab").forEach((tab) => {
            tab.addEventListener("click", function () {
              document
                .querySelectorAll(".tab")
                .forEach((t) => t.classList.remove("active"));
              this.classList.add("active");
              currentTab = this.getAttribute("data-tab");
              updateCarousel();
            });
          });
        }, 50);
      },
    });
  };

  // Función global para mostrar filtro alfabetico
  window.mostrarFiltroAlfabeto = function () {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        title: "<strong>Búsqueda Alfabética</strong>",
        html: `
        <div class="contenedor-alfabetico">
          <div class="contenedor-abc">
            <div id="alfabeto">
              ${crearBotonesAlfabeto()}
            </div>
          </div>
        </div>
      `,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          popup: "swal2-popup-custom", // Estilos personalizados
        },
      });
    } else {
      console.error("SweetAlert2 no ha cargado aún.");
    }
  };

  // Función para generar los botones del abecedario
  function crearBotonesAlfabeto() {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    return letras
      .map((letra) => {
        const isActive =
          letra === window.letraSeleccionada ? "active seleccionado" : "";
        return `
        <button class="btn-alfabeto ${isActive}" onclick="seleccionarLetra(this)">
          ${letra}
        </button>
      `;
      })
      .join("");
  }

  const filtroUno = document.querySelector(".filtro_uno");
  if (filtroUno) {
    filtroUno.addEventListener("click", mostrarFiltroAlfabeto, false);
  }

  // Función global para mostrar filtro por busqueda
  window.mostrarBusquedaCodigo = function () {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        title: "<strong>Búsqueda clave</strong>",
        html: `
        <p class="swal-texto">
          Digite la clave interna que desea buscar en el catálogo
        </p>
        <div class="swal-contenedor">
          <input type="text" id="codigoBusqueda" placeholder="Buscar" class="swal-input"/>
          <button onclick="buscarCodigo()" class="swal-boton btn-generic-home">
            Buscar 
            <svg class="icono-buscar" xmlns="http://www.w3.org/2000/svg" width="20.414" height="20.414" viewBox="0 0 20.414 20.414">
              <path id="icono_Buscar" data-name="icono Buscar" d="M21,21l-4.35-4.35M19,11a8,8,0,1,1-8-8A8,8,0,0,1,19,11Z" transform="translate(-2 -2)" fill="none" stroke="#061a6b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>
          </button>
        </div>
      `,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          popup: "swal2-popup-custom",
        },
      });
    } else {
      console.error("SweetAlert2 no ha cargado aún.");
    }
  };

  const filtroDos = document.querySelector(".filtro_dos");
  if (filtroDos) {
    filtroDos.addEventListener("click", mostrarBusquedaCodigo, false);
  }
  // Función global para mostrar filtro examen
  window.mostrarBusquedaExamen = function () {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        title: "<strong>Búsqueda por Nombre de Estudio</strong>",
        html: `
        <p class="swal-texto">
          Digite parte del nombre de estudio que desea buscar en el catálogo.
        </p>
        <div class="swal-contenedor">
          <input type="text" id="examenBusqueda" placeholder="Buscar" class="swal-input"/>
          <button onclick="buscarExamen()" class="swal-boton btn-generic-home">
            Buscar 
            <svg class="icono-buscar" xmlns="http://www.w3.org/2000/svg" width="20.414" height="20.414" viewBox="0 0 20.414 20.414">
              <path id="icono_Buscar" data-name="icono Buscar" d="M21,21l-4.35-4.35M19,11a8,8,0,1,1-8-8A8,8,0,0,1,19,11Z" transform="translate(-2 -2)" fill="none" stroke="#061a6b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>
          </button>
        </div>
      `,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          popup: "swal2-popup-custom",
        },
      });
    } else {
      console.error("SweetAlert2 no ha cargado aún.");
    }
  };

  const filtroTres = document.querySelector(".filtro_tres");
  if (filtroTres) {
    filtroTres.addEventListener("click", mostrarBusquedaExamen, false);
  }

  //modal tarjeta
  window.mostrarTarjetaExamenes = function (data) {
    const exam = data.exam;
    const muestra =
      data.sampleTypes && data.sampleTypes.length > 0
        ? data.sampleTypes[0]
        : {};
    if (typeof Swal !== "undefined") {
      Swal.fire({
        html: `
          <div class="modal-container">
            <div class="modal-header">
              <h2> ${exam.examName || ""} </h2>
            </div>
            <div class="modal-body">
              <div class="info-section">
              
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20.551" height="20.551" viewBox="0 0 20.551 20.551">
                    <path id="Código" d="M3,11.245V21.551M15.367,11.245V21.551M9.184,3V21.551M21.551,3V21.551" transform="translate(-2 -2)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <strong>Clave: </strong> ${exam.examCode || ""}
                </span>
                
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26.258" height="26.258" viewBox="0 0 26.258 26.258">
                    <path id="Tecnica" d="M18.981,9.277V5.639L22.62,2l1.213,2.426,2.426,1.213L22.62,9.277Zm0,0-4.852,4.852m12.129,0A12.129,12.129,0,1,1,14.129,2m6.065,12.129a6.065,6.065,0,1,1-6.065-6.065" transform="translate(-1 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <strong>Técnica: </strong> ${exam.examTechnique || ""} 
                </span>
                 
                <span class="price-modal icon">
                 <button class="btn-generic-home btn-what-catalog" style="padding: 10px 20px;">¡Consulta el precio aquí!</button>
                </span>
              </div>
  
              <hr>

              <div class="info-section-modal">
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30.241" height="20.346" viewBox="0 0 30.241 20.346">
                    <g id="Tipo_de_muestra" data-name="Tipo de muestra" transform="translate(-611.827 -477.827)">
                      <path id="Trazado_189326" data-name="Trazado 189326" d="M8.949,20H18.5a2.5,2.5,0,0,0,0-5H8.949M3,17.5A3.5,3.5,0,1,0,6.5,14,3.5,3.5,0,0,0,3,17.5Z" transform="matrix(0.017, 1, -1, 0.017, 633.789, 475.792)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      <path id="Trazado_189327" data-name="Trazado 189327" d="M8.949,20H18.5a2.5,2.5,0,0,0,0-5H8.949M3,17.5A3.5,3.5,0,1,0,6.5,14,3.5,3.5,0,0,0,3,17.5Z" transform="matrix(0.017, 1, -1, 0.017, 644.787, 475.6)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      <path id="Trazado_189328" data-name="Trazado 189328" d="M8.012,19.054h8.045a2.106,2.106,0,1,0,0-4.212H8.012M3,16.948A2.948,2.948,0,1,0,5.948,14,2.948,2.948,0,0,0,3,16.948Z" transform="matrix(0.017, 1, -1, 0.017, 654.731, 478.649)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </g>
                  </svg>
                  <strong>Tipo de Muestra:</strong> ${muestra.sampleType || ""}
                </span>
                
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20.678" height="23.346" viewBox="0 0 20.678 23.346">
                    <path id="Temperatura_optima" data-name="Temperatura optima" d="M22.178,3.067h-6.4m6.4,4.269h-6.4m6.4,4.269h-6.4M5.635,14.549V4.668a2.668,2.668,0,0,1,5.337,0v9.881a4.8,4.8,0,1,1-5.337,0ZM9.37,18.543A1.067,1.067,0,1,1,8.3,17.476,1.067,1.067,0,0,1,9.37,18.543Z" transform="translate(-2.5 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <strong>Temperatura óptima Envío:</strong> <span class="highlight"> ${
                    exam.optimumShippingTemperature || ""
                  } </span>
                  </span>
                  
                <span class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22">
                    <path id="Descripción_de_la_muestra" data-name="Descripción de la muestra" d="M14,2.27V6.4a2.484,2.484,0,0,0,.109,1.054,1,1,0,0,0,.437.437A2.484,2.484,0,0,0,15.6,8h4.13M16,13H8m8,4H8m2-8H8m6-7H8.8a7.453,7.453,0,0,0-3.162.327A3,3,0,0,0,4.327,3.638,7.453,7.453,0,0,0,4,6.8V17.2a7.453,7.453,0,0,0,.327,3.162,3,3,0,0,0,1.311,1.311A7.453,7.453,0,0,0,8.8,22h6.4a7.453,7.453,0,0,0,3.162-.327,3,3,0,0,0,1.311-1.311A7.453,7.453,0,0,0,20,17.2V8Z" transform="translate(-3 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <strong>Descripción de la muestra:</strong> ${
                    exam.sampleConditions || ""
                  } 
                </span>
              </div>

               <div class="info-section-modal">
                <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                  <path id="Estabilidad" d="M17.745,16a7.019,7.019,0,0,0,1.094-5.5M6.255,16A7,7,0,0,1,12,5a7.044,7.044,0,0,1,1.237.109M16.5,7.5,12,12m10,0A10,10,0,1,1,12,2,10,10,0,0,1,22,12Zm-9,0a1,1,0,1,1-1-1A1,1,0,0,1,13,12Z" transform="translate(-1 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </svg>
                <strong>Estabilidad:</strong>
                </span> 
               </div>
  
              <div class="tabla-contenedor">
              <table class="tabla-estilo">
                <thead>
                  <tr>
                    <th>Tipo de Muestra</th>
                    <th>Ambiente (18-25 ºC)</th>
                    <th>Refrigerada (2-8 ºC)</th>
                    <th>Congelada (-20ºC)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                    ${muestra.sampleType || ""} 
                    </td>
                    <td>
                    ${muestra.ambientTemperature || ""} 
                    </td>
                    <td>
                    ${muestra.refrigeratedTemperture || ""} 
                    </td>
                    <td>
                    ${muestra.frozenTemperature || ""} 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="info-section-modal">
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21.75" viewBox="0 0 21 21.75">
                  <path id="Procesamiento" d="M12,2.25v2.5M12,18v4M5.75,12H2.25m19,0h-1.5m-1.293,6.457-.707-.707m.914-12.334L17.25,6.83M4.922,19.078,7.75,16.25M5.129,5.209,7.25,7.33" transform="translate(-1.25 -1.25)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </svg>
                 <strong>Procesamiento:</strong> ${exam.processingDays || ""} 
              </span>
              
              <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="22" viewBox="0 0 20.414 22">
                <path id="Oportunidad_de_entrega" data-name="Oportunidad de entrega" d="M21,10H3m18,2.5V8.8a7.453,7.453,0,0,0-.327-3.162,3,3,0,0,0-1.311-1.311A7.453,7.453,0,0,0,16.2,4H7.8a7.453,7.453,0,0,0-3.162.327A3,3,0,0,0,3.327,5.638,7.453,7.453,0,0,0,3,8.8v8.4a7.453,7.453,0,0,0,.327,3.162,3,3,0,0,0,1.311,1.311A7.453,7.453,0,0,0,7.8,22H12M16,2V6M8,2V6m6.5,13,2,2L21,16.5" transform="translate(-2 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
              <strong>Tiempo de entrega:</strong> 
               ${exam.controlOpportunity || ""} 
              </span>
              <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.46" viewBox="0 0 20 20.46">
                <path id="Condición_especial" data-name="Condición especial" d="M10,8a2.248,2.248,0,0,1,4.369.749c0,1.5-2.248,2.248-2.248,2.248m.029,3h.01M7,18v2.336c0,.533,0,.8.109.936a.5.5,0,0,0,.391.188c.175,0,.383-.167.8-.5l2.385-1.908a6.352,6.352,0,0,1,1-.723,3,3,0,0,1,.762-.267A6.346,6.346,0,0,1,13.684,18H16.2a7.453,7.453,0,0,0,3.162-.327,3,3,0,0,0,1.311-1.311A7.453,7.453,0,0,0,21,13.2V7.8a7.453,7.453,0,0,0-.327-3.162,3,3,0,0,0-1.311-1.311A7.453,7.453,0,0,0,16.2,3H7.8a7.453,7.453,0,0,0-3.162.327A3,3,0,0,0,3.327,4.638,7.453,7.453,0,0,0,3,7.8V14a7.518,7.518,0,0,0,.1,1.776A3,3,0,0,0,5.224,17.9,7.52,7.52,0,0,0,7,18Z" transform="translate(-2 -2)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
               <strong>Condición especial:</strong>  ${
                 exam.conditionSpeciality || ""
               } 
              </span>
            </div>

            <div class="info-section-modal">
            <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="20.414" viewBox="0 0 20.414 20.414">
              <path id="Observaciones" d="M21,21l-4.35-4.35M19,11a8,8,0,1,1-8-8A8,8,0,0,1,19,11Z" transform="translate(-2 -2)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <strong>Observaciones:</strong>
            </span>
            </div>

            <div class="info-section">
              <div class="observations"> ${
                exam.preparationOrObservation || ""
              } </div>
            </div>
            
            <div class="info-section-modal">
              <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
              <path id="Importancia_clinica" data-name="Importancia clinica" d="M12,16V12m0-4h.01M22,12A10,10,0,1,1,12,2,10,10,0,0,1,22,12Z" transform="translate(-1 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            </span> <strong>Importancia Clínica:</strong>
            </div>
            
            <div class="info-section">
              <div class="clinical-importance">
                 ${exam.clinicalImportance || ""} 
              </div>
            </div>

            <div class="info-section-modal">
              <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                <path id="Componentes_del_test" data-name="Componentes del test" d="M12,2V7m0-5a10.041,10.041,0,0,0-2.08.217M12,2a10.04,10.04,0,0,1,2.08.217M12,7a5,5,0,0,0-5,5m5-5a5,5,0,0,1,5,5m-5,5v5m0-5a5,5,0,0,0,5-5m-5,5a5,5,0,0,1-5-5m5,10a10.043,10.043,0,0,0,2.077-.216M12,22a10.039,10.039,0,0,1-2.085-.218M4.929,4.929,8.464,8.464m7.071,7.071,3.535,3.536M2,12H7M2,12a10.041,10.041,0,0,0,.217,2.08M2,12a10.041,10.041,0,0,1,.217-2.083M17,12h5m0,0a10.04,10.04,0,0,0-.217-2.08M22,12a10.038,10.038,0,0,1-.216,2.079M4.929,19.071l3.536-3.536m7.071-7.071,3.535-3.536M17.447,3.612a10.053,10.053,0,0,1,2.942,2.943m0,10.895a10.053,10.053,0,0,1-2.941,2.94m-10.891,0a10.055,10.055,0,0,1-2.939-2.937m0-10.9A10.054,10.054,0,0,1,6.553,3.612" transform="translate(-1 -1)" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
              <strong>Componentes del Test:</strong> 
              ${exam.testComponents || ""} 
              </span> 
            </div>
          </div>
        </div>
      `,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
        confirmButtonColor: "#e31b79",
        confirmButtonText: "Cerrar",
        width: "750px",
        customClass: {
          popup: "custom-modal",
        },
      });
      // Evento modal whatsap
      document.querySelectorAll(".btn-what-catalog").forEach((btn) => {
        btn.addEventListener("click", async function () {
          showAlert({
            title: "¿Necesitas consultar precio?",
            text: '¡Comunícate con un asesor comercial! </br> </br> Correo electrónico: <strong class="email-link">aclientes.fact2@gmail.com</strong>',
            confirmText: '<i class="fab fa-whatsapp"></i> WhatsApp',
            url: "https://web.whatsapp.com/send?phone=525515289573",
          });
          setTimeout(() => {
            const alertContent = document.querySelector(
              ".swal2-html-container, .swal2-content, .swal2-textarea"
            );

            if (alertContent) {
              alertContent.addEventListener("click", (event) => {
                if (
                  event.target.innerText.includes("aclientes.fact2@gmail.com")
                ) {
                  window.location.href =
                    "mailto:aclientes.fact2@gmail.com?subject=Consulta%20de%20precio";
                }
              });
            }
          }, 100);
        });
      });
    } else {
      console.error("SweetAlert2 no ha cargado aún.");
    }
  };
});

function create_template_order_details(data) {
  var template = `
    <div class="cont-body-details">
      <div class="cont-title-details">
        <h3>Detalle orden: ${data.numOrder}<h3>
      </div>
      <div class="cont-data-details">
        <div class="cont-detail cd1">
          <span>Tipo de documento:</span>
          <p>${data.typeDoc}</p>
        </div>
        <div class="cont-detail cd2">
          <span>Tipo de documento:</span>
          <p>${data.numDoc}</p>
        </div>
        <div class="cont-detail cd3">
          <span>Tipo de documento:</span>
          <p>${data.names}</p>
        </div>
        <div class="cont-detail cd4">
          <span>Tipo de documento:</span>
          <p>${data.paternalSurname}</p>
        </div>
        <div class="cont-detail cd5">
          <span>Tipo de documento:</span>
          <p>${data.maternalSurname}</p>
        </div>
        <div class="cont-detail cd6">
          <span>Tipo de documento:</span>
          <p>${data.birdthDate}</p>
        </div>
        <div class="cont-detail cd7">
          <span>Tipo de documento:</span>
          <p>${data.age}</p>
        </div>
        <div class="cont-detail cd8">
          <span>Tipo de documento:</span>
          <p>${data.sex}</p>
        </div>
        <div class="cont-detail cd9">
          <span>Tipo de documento:</span>
          <p>${data.datetimeSample}</p>
        </div>
        <div class="cont-detail cd10">
          <span>Tipo de documento:</span>
          <p>${data.parcel}</p>
        </div>
        <div class="cont-detail cd11">
          <span>Tipo de documento:</span>
          <p>${data.numTicket}</p>
        </div>
        <div class="cont-detail cd12">
          <span>Tipo de documento:</span>
          <p>${data.pregnant}</p>
        </div>
        <div class="cont-detail cd13">
          <span>Tipo de documento:</span>
          <p>${data.observations}</p>
        </div>
      </div>
      <div class="cont-title-table">
        <h6>Servicios solicitados<h6>
      </div>
      <div class="cont-table-services">
        <div id="table-orders-details-id" class=""></div>
      </div>
      <div class="cont-prices-layout">
        <div class="cont-prices-details">
          <div class="cont-total-prices">
          <div class="cont-labels-prices">
            <span>Subtotal</span>
            <p>$${116}</p>
          </div>
          <div class="cont-labels-prices">
            <span>IVA</span>
            <p>${116}%</p>
          </div>
          <div class="cont-labels-prices">
            <span>Total</span>
            <p>$${104.4}</p>
          </div>
        </div>
        <div class="cont-total-prices">
          <div class="cont-labels-prices">
            <span>Descuento</span>
            <p>${0}%</p>
          </div>
          <div class="cont-labels-prices">
            <span>Anticipo</span>
            <p>$${50}</p>
          </div>
          <div class="cont-labels-prices label-blue">
            <span>Saldo</span>
            <p>$${54.4}</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  `;

  return template;
}

function show_modal_order_detail(data) {
  Swal.fire({
    html: create_template_order_details(data),
    confirmButtonText: "Cerrar",
    allowOutsideClick: true,
    width: "150rem",
    customClass: {
      confirmButton: "custom-confirm-btn-swal",
    },
  });

  create_table_datail(data.services);
}

function show_modal_order_print_tag(data) {
  Swal.fire("Modal Work" + data);
}

window.AvisosAlerts = {
  showModal(dataModal) {
    Swal.fire({
      title: dataModal.title,
      showCloseButton: false,
      confirmButtonText: dataModal.confirmText,

      html: `
       
       <div class="avisos__msj">
        <p class="avisos__text-1">
            ${dataModal.text1}
        </p>        
        <p class="avisos__text-2">
            ${dataModal.text2}
        </p>
            
        </div>
       
       `,
      customClass: {
        title: "avisos__title",
        confirmButton: "avisos__confirm-btn",
        container: "avisos__container",
        header: "avisos__header",
      },
    });
  },
};

function modal_new_orders_platform(url) {
  Swal.fire({
    showCloseButton: true,
    confirmButtonText:
      '<p>Crear Orden</p><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>',
    width: "130rem",
    html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
          <path id="Icono_mejora" data-name="Icono mejora" d="M62,32H56M53.213,53.213,48.97,48.971M8,32H2M15.029,15.03l-4.243-4.243M32,8V2M48.97,15.03l4.243-4.243M32,62V56M10.786,53.213l4.243-4.243M32,17l4.635,9.39L47,27.905l-7.5,7.3,1.77,10.32L32,40.655,22.73,45.53,24.5,35.21l-7.5-7.3L27.365,26.39Z" fill="none" stroke="#6e59ba" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
        </svg>
       <h2>Muy pronto cambiaremos nuestra plataforma de órdenes médicas para brindarle una mejor experiencia.</h2>
       <h3>¡Permanezca atento y descubra cómo mejoramos para cuidar de usted!</h3>
       `,
    customClass: {
      confirmButton: "btn-modal-redirect-orders",
      htmlContainer: "ctn-body-modal-redirect-orders",
    },
    preConfirm: () => {
      window.open(url, "_blank");
    },
  });
}

function modal_results_platform(url) {
  Swal.fire({
    showCloseButton: true,
    confirmButtonText: "Aceptar",
    width: "130rem",
    html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="55.428" height="55.118" viewBox="0 0 55.428 55.118">
          <path id="Trazado_190206" data-name="Trazado 190206" d="M37.4,43.342a7.752,7.752,0,0,1-14.976,4.013M2.288,26.8A10.354,10.354,0,0,1,5.006,16.656m23.353-5.03a6.46,6.46,0,1,0-8.968,2.4m30.087.127a10.354,10.354,0,0,0-7.427-7.427M42.169,21.2a12.6,12.6,0,0,0-6.845-8,16.793,16.793,0,0,0-11.608-.964,16.793,16.793,0,0,0-9.571,6.639,12.6,12.6,0,0,0-1.927,10.353,25.63,25.63,0,0,1,.266,13.692c-1.1,3.935-1.648,5.9-1.5,6.3a1.016,1.016,0,0,0,.743.75c.394.152,2.047-.29,5.353-1.177l30.66-8.215c3.306-.886,4.96-1.329,5.224-1.658a1.016,1.016,0,0,0,.268-1.021c-.069-.416-1.528-1.846-4.447-4.7A25.631,25.631,0,0,1,42.169,21.2Z" transform="translate(0.173 -0.006)" fill="none" stroke="#061a6b" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
        </svg>
       <h2>Recuerda que los resultados que vas a visualizar son anteriores al 30 de abril del 2025</h2>
       <h3>¡Sí tienes alguna duda o inquietud no dudes en comunicarte con nosotros!</h3>
       `,
    customClass: {
      confirmButton: "btn-modal-redirect-orders",
      htmlContainer: "ctn-body-modal-redirect-results",
    },
    preConfirm: () => {
      window.open(url, "_blank");
    },
  });
}
